import { app } from '../../../../../app';
import { Controller } from './group-accounts.controller';

app.component('companyUserDirectoriesManageGroupAccounts', {
    bindings: {
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./group-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/group-accounts.component.js